module.exports = __webpack_public_path__ + "static/media/1f-a2.893182ea.JPG";